// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-switcher {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .25em;
}

select#page-language {
  min-height: 0;
  cursor: pointer;
}

@media (min-width: 768px) {

}`, "",{"version":3,"sources":["webpack://./src/components/Authentication/LanguageSwitcher.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;;AAEA","sourcesContent":[".language-switcher {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: .25em;\n}\n\nselect#page-language {\n  min-height: 0;\n  cursor: pointer;\n}\n\n@media (min-width: 768px) {\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
